import React from "react";
import MainImage from "../../assets/HeroImages/MainPot7.jpg";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import PastWork from "../../components/PastWord";
import About from "../../components/About";
import Testimony from "../../components/Testimony";

function StrategicGrowthAccelerator() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F7F3F2]">
      <title>Strategic Growth Accelerator™ | Scale with SEO & Design | Her Growth Co.</title>
      <meta
        name="description"
        content="This accelerator is built for women ready to scale with focused SEO, elevated design, and clear marketing systems."
      />
      <meta
        name="keywords"
        content="scale your business online, growth strategy for women entrepreneurs, digital expansion package, next-level visibility systems, smart scaling for founders, long-term brand growth, SEO + web for scaling coaches, austin web design for women entrepreneurs, austin seo for female founders, website design for women-led businesses austin, custom websites for austin consultants, high-end website design austin, seo expert for women austin, premium branding austin women, austin digital authority launchpad, conversion-focused web design austin, web strategy for coaches austin, female entrepreneur seo services austin, austin cro expert services, all-in-one solution for experts, content marketing for women-led startups austin, seo for consultants in austin, website design agency austin tx, high-ticket client attraction austin, bespoke web design austin tx, online visibility for women founders, premium digital services austin, seo agency for women-owned business austin, women in business marketing austin, personal brand websites austin tx, social media + web strategy austin, website design for thought leaders austin"
      />

      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <Navbar />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl max-w-96 bg-[#CFF098] font-semibold text-center">The Strategic Growth Accelerator</h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-6xl uppercase">
                Ready to Attract More of Your Ideal Clients? It's Time to Strategically Grow Your Business Online.
              </h2>
              <p className="mb-8 mt-4 max-w-4xl text-base text-black md:mb-12 md:text-lg font-light">
                For established <strong>women-led businesses</strong> seeking to elevate their online authority, drive targeted traffic, and convert more leads into loyal clients.
              </p>
            </div>

            {/* Benefits Grid Styled Like Services.jsx */}
            <div className="mt-12">
              <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4">
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">A Conversion-Focused Website (Up to 7 Pages)</h3>
                  <p className="text-black text-base font-light">
                    Strategically designed to guide visitors through your funnel with dedicated service pages, compelling case studies, and clear CTAs that drive conversions.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Dominate Local Search</h3>
                  <p className="text-black text-base font-light">
                    Keyword research and on-site optimization for local visibility plus foundational Google Business and citation strategy.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Turn Visitors into Leads</h3>
                  <p className="text-black text-base font-light">
                    Capture leads with integrated forms and connect with your email marketing platform to nurture prospects automatically.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Showcase Your Success Stories</h3>
                  <p className="text-black text-base font-light">
                    Build trust with a stunning portfolio section featuring testimonials and real results.
                  </p>
                </div>
                <div className="grid gap-4 border border-solid border-black p-8 bg-white rounded-xl">
                  <h3 className="text-lg font-semibold text-black">Data-Driven Growth</h3>
                  <p className="text-black text-base font-light">
                    We’ll install Google Analytics and deliver an insights report to guide future strategy.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-16">
              <a href="/contact" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase">
                BOOK A STRATEGY SESSION
              </a>
            </div>
          </div>
        </section>
      
        <PastWork />
        <Testimony/>
          <div className="bg-[#2E2D2B]">
          <About/>
        </div>
        <Footer />
      </section>
    </main>
  );
}

export default StrategicGrowthAccelerator;
